import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';

import { modelOf } from '../../../prop-types';
import InfoPage from '../../../models/InfoPage';
import InfoPageStore from '../../../store/InfoPageStore';
import InfoPageList from '../InfoPageList';
import UIStore from '../../../store/UIStore';
import TopLevelNavigationDropdown from '../../common/TopLevelNavigationDropdown';
import ConfigStore from '../../../store/ConfigStore';

@observer
export class InfoPageNavigation extends Component {
  getActiveInfoPages = () => [
    ...this.props.currentInfoPage.ancestors,
    this.props.currentInfoPage
  ];

  getInfoPages = (id) => {
    const { infoPageStore } = this.props;

    return infoPageStore.pagesArray.filter(
      (page) => !page.parent_id && page.show_in_listing && page.id === id
    );
  };

  render() {
    const { currentInfoPage, uiStore, configStore } = this.props;
    const activeInfoPages = currentInfoPage ? this.getActiveInfoPages() : [];

    if (!uiStore.isDesktop) {
      return null;
    }

    return (
      <Fragment>
        {configStore.mainNavigation.useSidebar && (
          <TopLevelNavigationDropdown />
        )}
        <div className="InfoPageNavigation">
          {activeInfoPages.length > 0 && (
            <InfoPageList
              infoPages={this.getInfoPages(activeInfoPages[0].id)}
              activeInfoPages={activeInfoPages}
            />
          )}
        </div>
      </Fragment>
    );
  }
}

InfoPageNavigation.propTypes = {
  uiStore: modelOf(UIStore).isRequired,
  infoPageStore: modelOf(InfoPageStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  currentInfoPage: modelOf(InfoPage)
};

export default inject('infoPageStore', 'uiStore', 'configStore')(
  InfoPageNavigation
);



// WEBPACK FOOTER //
// ./src/components/info-page/InfoPageNavigation/index.jsx